module.exports = __webpack_public_path__ + "school/img/you.9d4030bc.jpg";